import { styled } from '@mui/material';
import Box from '@mui/material/Stack';
import Stack from '@mui/material/Stack';

const CAROUSEL_WIDTH = 424;
const CONTENT_WIDTH = 360;

export const StyledCarouselWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 4, 4, 0),
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: CAROUSEL_WIDTH, // TODO: get this as a component argument
  overflowX: 'hidden',
}));

export const StyledCarouselContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(5),
  padding: theme.spacing(6),
  height: '100%',
  borderRadius: theme.spacing(5),
  background: 'linear-gradient(to right, #53B1ED2B, #3C1AF92B)',
  overflowX: 'hidden',
}));

export const StyledCarouselCards = styled(Stack, {
  shouldForwardProp: (props) => props !== 'selectedIndex',
})<{ selectedIndex: number }>(({ theme, selectedIndex }) => ({
  gap: theme.spacing(6),
  flexDirection: 'row',
  transition: 'transform 0.5s ease',
  transform: `translateX(-${selectedIndex * (CONTENT_WIDTH + parseFloat(theme.spacing(6)))}px)`,

  '& > *': {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: CONTENT_WIDTH,
    opacity: 0,
    transition: 'opacity 0.8s ease',
  },

  [`& > *:nth-of-type(${selectedIndex + 1})`]: {
    opacity: 1,
  },
}));

export const StyledCarouselStepIndicatorContainer = styled(Stack)(
  ({ theme }) => ({
    gap: theme.spacing(2),
    flexDirection: 'row',
    justifyContent: 'center',
  }),
);

export const StyledCarouselStepIndicator = styled(Box, {
  shouldForwardProp: (props) => props !== 'isSelected',
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  opacity: isSelected ? 1 : 0.2,
  background: isSelected
    ? theme.palette['Colors/Foreground/fg-brand-primary_alt']
    : theme.palette['Component colors/Alpha/alpha-black-20'],
  height: 6,
  width: 45,
  borderRadius: 2,
  transition: 'opacity 0.5s ease',
}));
